enum TemplateStep {
  Home = 'Home',
  Builder = 'Build',
  Map = 'Map',
  Set = 'Set',
  TearsheetList = 'Tearsheet',
  TearsheetPreview = 'TearsheetPreview',
}

enum CreativeTemplatesManagerAgentToolName {
  GetTemplateByName = 'GetTemplateByName',
  NavigateToCreativeTemplatesLibrary = 'NavigateToCreativeTemplatesLibrary',
  NavigateToCreativeTemplateHomeOrSetOrTearsheetTab = 'NavigateToCreativeTemplateHomeOrSetOrTearsheetTab',
  ShowCreativeTemplatePreview = 'ShowCreativeTemplatePreview',
  GetCreativeTemplateInfo = 'GetCreativeTemplateInfo',
  CreateCreativeTemplate = 'CreateCreativeTemplate',
  DuplicateCreativeTemplate = 'DuplicateCreativeTemplate',
  BatchRenameTemplates = 'BatchRenameTemplates',
}

export {CreativeTemplatesManagerAgentToolName, TemplateStep};
